/* istanbul ignore file */
import { string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const CourseSectionDivisionConnectionParser = 
/* #__PURE__ */ parsers.object([
    ['id', codecString],
    ['username', codecString],
    ['name', codecString],
]);
export class CourseSectionDivisionConnection extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return CourseSectionDivisionConnectionParser.decode(input).map(res => new CourseSectionDivisionConnection(res));
    }
    static unsafeDecode(input) {
        return CourseSectionDivisionConnection.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return CourseSectionDivisionConnectionParser.encode(data);
    }
    static schema() {
        return CourseSectionDivisionConnectionParser.schema();
    }
}
